// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimAppealRequestDto
 */
export interface IClaimAppealRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimAppealRequestDto
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimAppealRequestDto
     */
    document_file_paths?: Array<string>;
}

/**
 * Check if a given object implements the IClaimAppealRequestDto interface.
 */
export function instanceOfIClaimAppealRequestDto(value: object): value is IClaimAppealRequestDto {
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function IClaimAppealRequestDtoFromJSON(json: any): IClaimAppealRequestDto {
    return IClaimAppealRequestDtoFromJSONTyped(json, false);
}

export function IClaimAppealRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimAppealRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'document_file_paths': json['document_file_paths'] == null ? undefined : json['document_file_paths'],
    };
}

export function IClaimAppealRequestDtoToJSON(json: any): IClaimAppealRequestDto {
    return IClaimAppealRequestDtoToJSONTyped(json, false);
}

export function IClaimAppealRequestDtoToJSONTyped(value?: IClaimAppealRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'document_file_paths': value['document_file_paths'],
    };
}

